module.exports = __webpack_public_path__ + "img/Saint Gobain.78c5baae.jpg";